import React from 'react'

function BreadGallery() {
  const breads = [
    { name: 'Pão Francês', img: 'https://static.lumi.new/63/63b87d79959077004245eaeaf8adf198.png' },
    { name: 'Pão de Forma', img: 'https://static.lumi.new/a5/a52f71399b55163e843b29be61772917.png' },
    { name: 'Brioche', img: 'https://static.lumi.new/21/21056564d328ca302093cc5281607289.png' },
    { name: 'Croissant', img: 'https://static.lumi.new/4c/4c4e482686b0d96b84c5133285052420.png' },
    { name: 'Pizza', img: 'https://static.lumi.new/0c/0c7270afcfc56a356db5c50d977e52a8.png' },
    { name: 'Focaccia', img: 'https://static.lumi.new/75/75bda545d8b10c30a993ab6e0d9f8468.png' },
    { name: 'Pão Doce', img: 'https://static.lumi.new/04/04b97725b4a1988d6242e24bc4bfd927.png' },
    { name: 'Pão de Hambúrguer', img: 'https://static.lumi.new/c9/c9c315a3d42baec3d11f64ad92f2bf81.png' },
  ]

  return (
    <section className="bg-[#FCFAF5] py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 animate-fade-up">
          <h2 className="font-display text-[#49352B] text-3xl md:text-5xl font-bold mb-4">
            🍞 Veja alguns dos pães que você poderá fazer em casa
          </h2>
          <p className="text-[#49352B]/70 text-lg max-w-2xl mx-auto">
            Todos 100% sem glúten, extremamente macios por dentro, dourados por fora e com sabor de padaria.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
          {breads.map((b, i) => (
            <div
              key={i}
              className="group relative rounded-[20px] overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 animate-fade-up"
            >
              <img
                src={b.img}
                alt={b.name}
                className="w-full h-56 md:h-64 object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                <p className="text-white font-display font-bold text-lg">{b.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default BreadGallery
